import { Container, Heading, VStack } from '@chakra-ui/react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from '@/components/ContactUs/Header';
import { ContactForm } from '@/components/ui/features/contact-form/ContactForm/ContactForm';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { ContactType } from '@/resources/Contact';

const Support: NextPage = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <NextSeo title="Contact Us - Support" />
      <Layout>
        <Header type={ContactType.SUPPORT} />
        <Container maxW={{ base: 'full', md: '75%', lg: '50%' }} as={VStack} alignItems="flex-start">
          <Heading
            pt="80px"
            pb="20px"
            as="h2"
            fontSize={{ base: '32px', md: '48px' }}
            lineHeight={{ base: '48px', md: '56px' }}
            fontWeight={700}
          >
            {t('contactForm.subtitle.support')}
          </Heading>
          <ContactForm type={ContactType.SUPPORT} />
        </Container>
      </Layout>
    </Fragment>
  );
};

export default Support;
